
export default function NoDataFound() {
    return (
        <div className='nodata'>
            <i className='icon nodatafound'></i>
            <h1 >No Data Found</h1>
        </div>
    )
}